export const getCssProp = (name: string): string => {
  const varName = name.includes('--') ? name.slice(2) : name
  const stylesBody = getComputedStyle(document.documentElement)
  return String(stylesBody.getPropertyValue(`--${varName}`).trim())
}
export const setCssProp = (name: string, setValue: string): void => {
  const varName = name.includes('--') ? name.slice(2) : name
  const stylesBody = getComputedStyle(document.documentElement)
  stylesBody.setProperty(`--${varName}`, setValue)
}
